export enum SLIDER_ELEMENT_NAME {
  innerView = 'innerView',
  railContainer = 'sliderRailContainer',
  rail = 'sliderRail',
  startText = 'sliderStartText',
  endText = 'sliderEndText',

  startHandler = 'sliderStartHandler',
  startHandlerText = 'startHandlerText',
  endHandler = 'sliderEndHandler',
  endHandlerText = 'sliderEndHandlerText',

  track = 'sliderTrack',

  trackContainer = 'sliderTrackContainer'
}
